import rootReducer from '../reducers/index';
import { compose, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import createDebounce from 'redux-debounced';

/**
 *
 * @return { StoreCreator }
 */
export default function configureStore() {
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: ['local', 'dev'].includes(process.env.ENV) })() :
      compose;
  const middleware = process.env.ENV !== 'prod' ? [createDebounce(), thunk, logger] : [createDebounce(), thunk];

  return createStore(
      rootReducer,
      compose(
          applyMiddleware(...middleware),
          composeEnhancers,
      ),
  );
}
